import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ScreenRotationIcon from '@mui/icons-material/ScreenRotationRounded';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import SimpleModal from './index';
import IconText from 'components/Labels/IconText';
import ProgressModal from './ProgressModal';

interface Props {
  onClose: () => void;
}

function ReloadModal(props: Props) {
  const { t } = useTranslation();
  const { onClose } = props;
  const [openProgress, setProgress] = useState<boolean>(false);

  const handlerreloadPage = () => {
    setProgress(true);
    window.location.reload();
  };

  return (
    <div>
      <SimpleModal open={openProgress} onClose={() => console.warn('reloading...')}>
        <ProgressModal title="" size={150} />
      </SimpleModal>

      <IconText
        icon={<ScreenRotationIcon />}
        variant="h6"
        text={t('components.modals.resize.title')}
      />
      <Typography my={2} sx={{ whiteSpace: 'pre-line' }}>
        {t('components.modals.resize.content')}
      </Typography>
      <Stack direction="row" justifyContent="flex-end" p={1} spacing={1}>
        <Button variant="text" color="primary" onClick={onClose}>
          {t('components.modals.resize.btn_cancel')}
        </Button>
        <Button variant="contained" color="primary" onClick={handlerreloadPage}>
          {t('components.modals.resize.btn_reload')}
        </Button>
      </Stack>
    </div>
  );
}

export default ReloadModal;
